import {
  IItem,
  ImageItem,
  IImageDrawable,
} from "../../../../../../../domain/document/items";
import { IValueAccessible } from "../IValueAccessible";
import { AbstractValueAccessor, AbstractImageDrawableAccessor } from "./AbstractValueAccessor";

export class ImageDrawableRotationAngleAccessor extends AbstractValueAccessor<number> {
  constructor(source: IItem) {
    super(ImageDrawableRotationAngleAccessor._createAccessor(source));
  }
  
  private static _createAccessor(source: IItem): IValueAccessible<number> {
    if (source instanceof ImageItem) {
      return new ImageItemRotationAngleAccessor(source);
    }
    throw new Error("対象外オブジェクト");
  }
}

abstract class AbstractRotationAngleAccessor<T extends IItem & IImageDrawable> extends AbstractImageDrawableAccessor<T, number> {
  constructor(source: T) {
    super(source);
  }
}

class ImageItemRotationAngleAccessor extends AbstractRotationAngleAccessor<ImageItem> {
  constructor(source: ImageItem) {
    super(source);
  }

  protected _validate(source: ImageItem): void {}

  protected _get(source: ImageItem): number {
    return source.rotationAngle;
  }

  protected _set(source: ImageItem, value: number): void {
    source.rotationAngle = value;
  }
}
